import React, { useState } from "react";
import styled from "styled-components";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import { FaDatabase } from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";
import { MdLaptopMac } from "react-icons/md";
import DashHeader from "./DashHeader";
import { Link } from "react-router-dom";

const DashboardSidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <DashHeader />
      <Container>
        <SidebarMain>
          <Sidebar
            style={{
              width: isOpen ? "200px" : "50px",
              paddingLeft: isOpen ? "15px" : "15px",
            }}
          >
            <Icon onClick={toggle}>
              {isOpen ? (
                <MdOutlineKeyboardArrowLeft className="icon" />
              ) : (
                <MdOutlineKeyboardArrowRight className="icon" />
              )}
            </Icon>
            <TopSection>
              {isOpen ? null : <BorderBottom></BorderBottom>}
              <Title>
                {isOpen ? (
                  <>
                    <FaDatabase className="icon" />
                    Overview
                  </>
                ) : (
                  <FaDatabase
                    className="icon"
                    style={{
                      marginBottom: "10px",
                    }}
                  />
                )}
              </Title>
              {isOpen ? null : <BorderBottom></BorderBottom>}
              <ListItem style={{ display: isOpen ? "block" : "none" }}>
                <li>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
              </ListItem>
              <Title>
                {isOpen ? (
                  <>
                    <MdLaptopMac className="icon" />
                    Support
                  </>
                ) : (
                  <MdLaptopMac
                    className="icon"
                    style={{ marginBottom: "10px" }}
                  />
                )}
              </Title>
              {isOpen ? null : <BorderBottom></BorderBottom>}
              <ListItem style={{ display: isOpen ? "block" : "none" }}>
                <li>
                  <Link to="/plans">Plan</Link>
                </li>
                <li>
                  <Link to="/documentation">Documentation</Link>
                </li>
                <li>
                  <Link to="/ticket">Raise a Ticket</Link>
                </li>
              </ListItem>
              <Title>
                {isOpen ? (
                  <>
                    <AiFillSetting className="icon" />
                    Settings
                  </>
                ) : (
                  <AiFillSetting
                    className="icon"
                    style={{ marginBottom: "10px" }}
                  />
                )}
              </Title>
              {isOpen ? null : <BorderBottom></BorderBottom>}
              <ListItem style={{ display: isOpen ? "block" : "none" }}>
                <li>
                  <Link to="/manage-account">Manage Account</Link>
                </li>
                <li>
                  <Link to="/feedback">Give us feedback</Link>
                </li>
              </ListItem>
            </TopSection>
          </Sidebar>
        </SidebarMain>
        <Main>{children}</Main>
      </Container>
    </>
  );
};

export default DashboardSidebar;

const Container = styled.div`
  display: flex;
`;

const SidebarMain = styled.div`
  @media only screen and (max-width: 991px) {
    display: none;
  }
`;

const Sidebar = styled.div`
  background: rgb(255, 255, 255);
  color: #000;
  height: 91vh;
  width: 200px;
  transition: all 0.5s;
  box-shadow: 2px 0 2px -0.5px rgba(0, 0, 0, 0.2);
  position: relative;
`;

const TopSection = styled.div`
  padding-top: 1rem;
`;

const Icon = styled.div`
  position: absolute;
  bottom: 3%;
  right: -15%;
  cursor: pointer;

  .icon {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    background-color: #fff;
    border: 1px solid darkgreen;
    color: #333;
    border-radius: 50%;
    font-size: 13px;
    height: 40px;
    width: 40px;
  }
`;

const Main = styled.div`
  width: 100%;
  padding: 20px 30px;
  padding-bottom: 0px;
  overflow-y: scroll;
  height: 90vh;
  background: rgb(255, 255, 255);

  @media only screen and (max-width: 991px) {
    overflow-x: hidden;
    padding: 10px 10px;
  }
`;

const BorderBottom = styled.div`
  background-color: #cfcfcf;
  width: 50px;
  height: 1px;
  margin-left: -15px;
  margin-bottom: 16px;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 500;
  color: #333;
  margin-bottom: 5px;
  cursor: pointer;

  .icon {
    margin-right: 5px;
    font-size: 20px;
    color: #005800;
  }
`;

const ListItem = styled.ul`
  margin: 15px 0px;
  li {
    list-style: none;
    font-size: 15px;
    font-weight: 500;
    margin-bottom: 5px;
    cursor: pointer;

    a {
      color: rgb(0, 104, 74);
    }
  }
`;
